import { Store } from 'react-notifications-component';
import { format, addMonths, parseISO, isAfter } from 'date-fns';

/*
 displayMessage("success | danger ", "String Title", `String Sub-title`);
*/
function displayMessage(type, title, message) {
    Store.addNotification({
      title: title,
      message: message,
      type: type,
      insert: "top",
      container: "bottom-left",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: false,
        pauseOnHover: true
      },
     
    });
  }

  function formatDateToDDMMMYYYY(date) {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    
    const day = String(date.getDate()).padStart(2, '0'); // Ensure 2 digits
    const month = months[date.getMonth()]; // Get the short month name
    const year = date.getFullYear(); // Get the full year
    
    return `${day}-${month}-${year}`;
}

/*
storageType : 'local' | 'session'
storageObjectName : string

*/
function setValue(storageType, storageObjectName, propertyName, value) {
  let storageObjectStr = null;
  if (storageType.toLowerCase() === 'local') {
    storageObjectStr = localStorage.getItem(storageObjectName);
  } else if (storageType.toLowerCase() === 'session') {
    storageObjectStr = sessionStorage.getItem(storageObjectName);
  }
  let storeObject = null;
  if (storageObjectStr !== null) {
    storeObject = JSON.parse(storageObjectStr);
    if(propertyName && storeObject){
      storeObject[propertyName] = value;
    }else if(!propertyName && storeObject){
      storeObject = value;
    }else{
      return false; // when propertyName is defined but not the storageObjectName
    }
  }else{
    storeObject = {};
    if(propertyName && storageObjectName){
      storeObject[propertyName] = value;
    }else if(!propertyName && storeObject){
      storeObject = value;
    }else{
      return false; // when propertyName is defined but not the storageObjectName
    }
  }

  if (storageType.toLowerCase() === 'local') {
    localStorage.setItem(storageObjectName, JSON.stringify(storeObject));
  } else if (storageType.toLowerCase() === 'session') {
    sessionStorage.setItem(storageObjectName, JSON.stringify(storeObject));
  }
  return true;
}

function getValue(storageType, storageObjectName, propertyName) {
  let storageObjectStr = null;
  if (storageType.toLowerCase() === 'local') {
    storageObjectStr = localStorage.getItem(storageObjectName);
  } else if (storageType.toLowerCase() === 'session') {
    storageObjectStr = sessionStorage.getItem(storageObjectName);
  }
  if (storageObjectStr !== null) {
    let storeObject = JSON.parse(storageObjectStr); //https://stackoverflow.com/questions/42494823/json-parse-returns-string-instead-of-object
    if (propertyName && storeObject.hasOwnProperty(propertyName)) {
      return storeObject[propertyName];
    } else {
      return storeObject;
    }
  }
  else {
    return null;
  }
}

function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}



function generateMonthYearLabels(startDate, endDate) {
  if (!startDate || !endDate) return [];
  const start = parseISO(startDate);
  const end = parseISO(endDate);
  const labels = [];
  let current = start;

  while (!isAfter(current, end)) {
    labels.push(format(current, 'MMM yyyy')); // e.g., Jan 2025
    current = addMonths(current, 1);
  }

  return labels;
}


  export {
    displayMessage,
    formatDateToDDMMMYYYY,
    setValue,
    getValue,
    isEmpty,
    generateMonthYearLabels,
  }


